
import Myroutes from "./routes/myroutes";
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en.json'
import ru from 'javascript-time-ago/locale/ru.json'
import A11yProvider from "./a11y/AccessibilityProvider";
import { LangProvider } from "./context/LangContext";

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);

function App() {
  return (
    <LangProvider>
      <A11yProvider>
        <Myroutes />
      </A11yProvider>
    </LangProvider>
  );
}

export default App;
